// deps
import React, { ReactElement, memo, useEffect, useState } from "react";

// internal-deps
import { NewTag, SESSION_STORAGE_KEYS, Storage } from "@swiggy-private/core-ui";

// styles
import { AnimatedChar, DownArrowIcon, StaticChar, StyledNewTagWrapper } from "./AnimatedTitle.styled";

interface AnimatedTitleProps {
    text: string;
}

const AnimatedTitle = ({ text }: AnimatedTitleProps): ReactElement => {
    const [shouldAnimate] = useState(
        () => !Storage.getItem<boolean>(SESSION_STORAGE_KEYS.DELIVERY_SPEED_CROUTON_SEEN, false),
    );

    useEffect(() => {
        if (shouldAnimate) {
            Storage.setItem(SESSION_STORAGE_KEYS.DELIVERY_SPEED_CROUTON_SEEN, true);
        }
    }, [shouldAnimate]);

    const Char = shouldAnimate ? AnimatedChar : StaticChar;

    return (
        <>
            {Array.from(text).map((ch, idx) => (
                <Char key={idx} $index={idx}>
                    {ch === " " ? "\u00A0" : ch}
                </Char>
            ))}
        </>
    );
};

export const AnimatedTitlePreText = (): ReactElement => (
    <StyledNewTagWrapper>
        <NewTag customBorderRadius="8px 8px 8px 0" />
    </StyledNewTagWrapper>
);

export const AnimatedTitlePostText = (): ReactElement => <DownArrowIcon />;

export default memo(AnimatedTitle);
